import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ExemptionPolicyDetailFields from './ExemptionPolicyDetailFields'

export const ExemptionPolicyDetailCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ExemptionPolicyDetailFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ExemptionPolicyDetailCreate
